import React from 'react';
import { compareData } from '../data/mockData';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ComparisonTable = () => {
  return (
    <section className="py-24 bg-slate-50 border-t border-slate-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center mb-16">
          <div className="mono-label text-indigo-600 mb-3">Benchmarking</div>
          <h2 className="text-3xl font-extrabold text-slate-900 mb-4">Metric Comparison</h2>
          <p className="text-slate-500">
            Compare mechanical tolerances and warranty structures across our chassis lineup.
          </p>
        </div>

        {/* Mobile: Card View */}
        <div className="lg:hidden space-y-6">
          {['Horizon Basic', 'Horizon Pro', 'Horizon Max'].map((model, modelIdx) => (
            <div key={model} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm">
              <div className={`p-4 border-b border-slate-100 flex justify-between items-center ${model === 'Horizon Pro' ? 'bg-indigo-50/50' : 'bg-slate-50'}`}>
                <h3 className="font-bold text-slate-900">{model}</h3>
                {model === 'Horizon Pro' && <span className="text-[10px] font-mono bg-indigo-600 text-white px-2 py-0.5 rounded">RECOMMENDED</span>}
              </div>
              <div className="p-4 space-y-3">
                {compareData.map((row, rowIdx) => (
                  <div key={rowIdx} className="flex justify-between text-sm">
                    <span className="text-slate-400 font-mono text-[10px] uppercase">{row.feature}</span>
                    <span className="font-semibold text-slate-700">{row[`item${modelIdx + 1}`]}</span>
                  </div>
                ))}
                <button className="w-full mt-4 py-2 border-2 border-slate-100 hover:border-indigo-600 hover:text-indigo-600 rounded-lg text-sm font-bold transition-all">
                  Select Model
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop: Table View */}
        <div className="hidden lg:block overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl shadow-slate-200/50">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-slate-50">
                <th className="px-8 py-6 border-b border-slate-200 text-xs font-mono text-slate-400 uppercase tracking-widest">Parameter</th>
                <th className="px-8 py-6 border-b border-slate-200 text-center font-bold text-slate-900">Horizon Basic</th>
                <th className="px-8 py-6 border-b border-indigo-100 text-center bg-indigo-50/30 border-x border-indigo-100">
                  <div className="flex flex-col items-center">
                    <span className="text-[9px] font-mono bg-indigo-600 text-white px-2 py-0.5 rounded-full mb-2">RECOMMENDED</span>
                    <span className="font-bold text-indigo-900">Horizon Pro</span>
                  </div>
                </th>
                <th className="px-8 py-6 border-b border-slate-200 text-center font-bold text-slate-900">Horizon Max</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {compareData.map((row, idx) => (
                <tr key={idx} className="hover:bg-slate-50 transition-colors group">
                  <td className="px-8 py-5 font-medium text-slate-500 text-sm group-hover:text-slate-900">{row.feature}</td>
                  <td className="px-8 py-5 text-slate-600 text-center text-sm">{row.item1}</td>
                  <td className="px-8 py-5 text-indigo-900 font-bold text-center text-sm bg-indigo-50/10 border-x border-indigo-50">
                    {row.item2}
                  </td>
                  <td className="px-8 py-5 text-slate-600 text-center text-sm">{row.item3}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="bg-slate-50/50">
                <td className="px-8 py-8 border-t border-slate-200"></td>
                <td className="px-8 py-8 border-t border-slate-200 text-center">
                  <button className="text-slate-400 hover:text-indigo-600 font-bold text-sm transition-colors underline underline-offset-4">Configure</button>
                </td>
                <td className="px-8 py-8 border-t border-indigo-100 text-center bg-indigo-50/30 border-x border-indigo-100">
                  <button className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-xl text-sm shadow-lg shadow-indigo-100 transition-all transform hover:scale-105 active:scale-95">
                    Select Pro
                  </button>
                </td>
                <td className="px-8 py-8 border-t border-slate-200 text-center">
                  <button className="text-slate-400 hover:text-indigo-600 font-bold text-sm transition-colors underline underline-offset-4">Configure</button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;